import React, { useMemo } from 'react';
import { StyleSheet, TextInput, View } from 'react-native';
import { useRouter } from 'expo-router';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTheme } from '@/context/ThemeContext';
import Icon from '@/components/Icon';
import Button from '@/components/Buttons/Button';
import useResponsiveness from '@/hooks/useResponsiveness';

const createStyles = (colors, isXS, insets) => StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    paddingHorizontal: 12 + Math.max(insets.left, insets.right),
    paddingTop: 10 + insets.top,
    paddingBottom: 8,
    backgroundColor: colors.solid_color_block,
  },
  searchContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.solid_color_secondary,
    borderRadius: 8,
    paddingRight: 8,
    paddingLeft: 12,
    height: 36,
  },
  searchIcon: {
    marginRight: 10,
  },
  searchInput: {
    flex: 1,
    fontSize: isXS ? 15 : 14,
    color: colors.text_color_primary,
    height: '100%',
    outlineWidth: 0,
    outlineStyle: 'none',
  },
  cancelButton: {
    paddingVertical: 0,
    paddingLeft: 0,
    minWidth: 0,
  }
});

function SearchHeader({ 
  value,
  onChangeText,
  placeholder = "Search",
  cancelRoute = "../",
  autoFocus = true,
  maxLength,
}) {
  const { colors } = useTheme();
  const router = useRouter();
  const { isXS } = useResponsiveness();
  const insets = useSafeAreaInsets();
  const styles = useMemo(() => createStyles(colors, isXS, insets), [colors, isXS, insets]);
  
  return (
    <View style={styles.header}>
      <View style={styles.searchContainer}>
        <Icon 
          name="magnifying-glass" 
          size={14} 
          color={colors.text_color_secondary} 
          style={styles.searchIcon} 
        />
        <TextInput
          autoComplete='none'
          autoCorrect={false}
          autoCapitalize='none'
          spellCheck={false}
          clearButtonMode="while-editing"
          style={styles.searchInput}
          placeholder={placeholder}
          placeholderTextColor={colors.color_input_placeholder}
          autoFocus={autoFocus}
          value={value}
          onChangeText={onChangeText}
          maxLength={maxLength}
        />
      </View>
      <Button
        text="Cancel"
        variant="transparent"
        size="medium"
        hoverBackgroundColor="transparent"
        onPress={() => router.push(cancelRoute)}
        style={styles.cancelButton}
      />
    </View>
  );
};

export default React.memo(SearchHeader); 